/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Row,
} from "reactstrap";
import Select from "react-select";
import MaterialTable from "material-table";

//Context
import { useAuth } from "../../../context/auth";

//API
import {
  api_DELETE,
  api_GET,
  api_POST,
  api_PUT,
} from "../../../services/api_service";

//Services
import { showMessage, showQuestion } from "../../../services/message";

//Constants
import { table_style } from "../../../constants/MaterialTable";
import { table_translate } from "../../../constants/MaterialTable";

//Helpers
import mascaras from "../../../helpers/mascaras";

export default function DestinoPGRCC({
  item,
  opcao,
  handleProximoStep,
  handleStepAnterior,
}) {
  const { setLoading } = useAuth();
  const { handleSubmit } = useForm({ mode: "onBlur" });
  const [registro, setRegistro] = useState(null);
  const [destinosSelecionados, setDestinosSelecionados] = useState([]);
  const [optionsDestinos, setOptionsDestinos] = useState([]);
  const [selectedDestino, setSelectedDestino] = useState(null);

  const loadOptionsDestinos = async () => {
    setLoading(true);
    try {
      const { data } = await api_GET(
        `ProtocoloDestino/GetListProtocoloDestino`
      );

      const isRequerimento = opcao.tipoCadastro === "Requerimento";

      // destinos já salvos
      const destinosSalvos = isRequerimento
        ? item?.requerimentoGerador?.[0]?.requerimentoGeradorDestinosPGRCC || []
        : item?.protocoloGerador?.[0]?.protocoloGeradorDestinosPGRCC || [];

      const options = data.map((value) => {
        const encontrado = destinosSalvos.find(
          (t) => t.cnpjDestino === value.cpf_Cnpj
        );

        return {
          label: value.razaoSocial,
          value: value.cpf_Cnpj,
          ...value,
          ...(isRequerimento && encontrado
            ? {
                requerimentoGeradorDestinosPGRCC_Id:
                  encontrado.requerimentoGeradorDestinosPGRCC_Id,
              }
            : {}),
          ...(!isRequerimento && encontrado
            ? {
                protocoloGeradorDestinosPGRCC_Id:
                  encontrado.protocoloGeradorDestinosPGRCC_Id,
              }
            : {}),
        };
      });

      setOptionsDestinos(options);

      // Selecionar apenas os Destinos que foram salvos
      const selecionados = options.filter((opt) =>
        destinosSalvos.some((t) => t.cnpjDestino === opt.value)
      );

      setDestinosSelecionados(selecionados);
    } catch (err) {
      showMessage("Error", err?.message ?? "Error na Operação!", "error", null);
    } finally {
      setLoading(false);
    }
  };

  function handleAdicionarTransportador() {
    if (!selectedDestino) return;

    const existe = destinosSelecionados.some(
      (t) => t.value === selectedDestino.value
    );
    if (existe) {
      showMessage(
        "Aviso",
        "Este transportador já foi adicionado.",
        "warning",
        null
      );
      return;
    }

    setDestinosSelecionados((prev) => [...prev, selectedDestino]);
    setSelectedDestino(null);
  }

  function handleCriarObjetoTipoRequerimento(data) {
    const requerimentoGeradorId =
      registro?.requerimentoGerador?.[0]?.requerimentoGerador_Id;

    return {
      requerimentoGeradorDestinosPGRCC: destinosSelecionados.map((t) => ({
        requerimentoGeradorDestinosPGRCC_Id:
          t.requerimentoGeradorDestinosPGRCC_Id ?? 0,
        cnpjDestino: t.cpf_Cnpj,
        requerimentoGerador_Id: requerimentoGeradorId,
      })),
    };
  }

  function handleCriarObjetoTipoProtocolo(data) {
    const protocoloGeradorId =
      registro?.protocoloGerador?.[0]?.protocoloGerador_Id;

    return {
      protocoloGeradorDestinosPGRCC: destinosSelecionados.map((t) => ({
        protocoloGeradorDestinosPGRCC_Id:
          t.protocoloGeradorDestinosPGRCC_Id ?? 0,
        protocoloGerador_Id: protocoloGeradorId,
        cnpjDestino: t.cpf_Cnpj,
      })),
    };
  }

  async function handleDeleteDestino(rowData) {
    showQuestion(
      "Aviso",
      "Tem certeza que deseja remover este destino?",
      "question",
      async function (retorno) {
        if (!retorno) return;

        const isRequerimento = opcao.tipoCadastro === "Requerimento";
        const index = rowData?.tableData?.id;

        setLoading(true);
        try {
          // Remove via API se tiver ID
          if (isRequerimento) {
            const id = rowData?.requerimentoGeradorDestinosPGRCC_Id;
            if (id) {
              await api_DELETE(
                `RequerimentoGerador/DeleteRequerimentoGeradorDestinosPGRCC/${id}`
              );
            }
          } else {
            const id = rowData?.protocoloGeradorDestinosPGRCC_Id;
            if (id) {
              await api_DELETE(
                `ProtocoloGerador/DeleteProtocoloGeradorDestinosPGRCC/${id}`
              );
            }
          }

          // Remove do estado pelo índice
          setDestinosSelecionados((prev) => prev.filter((_, i) => i !== index));

          setRegistro((prevRegistro) => {
            const novoRegistro = { ...prevRegistro };

            if (isRequerimento) {
              novoRegistro.requerimentoGerador[0].requerimentoGeradorDestinosPGRCC =
                novoRegistro.requerimentoGerador[0].requerimentoGeradorDestinosPGRCC.filter(
                  (_, i) => i !== index
                );
            } else {
              novoRegistro.protocoloGerador[0].protocoloGeradorDestinosPGRCC =
                novoRegistro.protocoloGerador[0].protocoloGeradorDestinosPGRCC.filter(
                  (_, i) => i !== index
                );
            }

            return novoRegistro;
          });
        } catch (err) {
          showMessage(
            "Erro",
            err?.message ?? "Erro ao excluir Destino",
            "error",
            null
          );
        } finally {
          setLoading(false);
        }
      }
    );
  }

  const onSubmit = async (data) => {
    if (destinosSelecionados.length === 0)
      return showMessage(
        "Aviso",
        "Adicione pelo menos um destino!",
        "warning",
        null
      );

    const isRequerimento = opcao.tipoCadastro === "Requerimento";

    if (isRequerimento) {
      setLoading(true);
      try {
        const objRequerimentoDestinos = handleCriarObjetoTipoRequerimento(data);

        let destinosSalvos = [];

        for (const destino of objRequerimentoDestinos.requerimentoGeradorDestinosPGRCC) {
          let resposta;
          if (!destino.requerimentoGeradorDestinosPGRCC_Id) {
            resposta = await api_POST(
              "RequerimentoGerador/PostRequerimentoGeradorDestinosPGRCC",
              destino
            );
          } else {
            resposta = await api_PUT(
              "RequerimentoGerador/PutRequerimentoGeradorDestinosPGRCC",
              destino
            );
          }

          if (resposta?.data) {
            destinosSalvos.push(resposta.data);
          }
        }

        const registroAtualizado = { ...registro };
        if (registroAtualizado.requerimentoGerador?.[0]) {
          registroAtualizado.requerimentoGerador[0].requerimentoGeradorDestinosPGRCC =
            destinosSalvos;
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Erro",
          error?.message ?? "Erro na operação",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      try {
        const objProtocoloDestinos = handleCriarObjetoTipoProtocolo(data);

        let destinosSalvos = [];

        for (const destino of objProtocoloDestinos.protocoloGeradorDestinosPGRCC) {
          let resposta;
          if (!destino.protocoloGeradorDestinosPGRCC_Id) {
            resposta = await api_POST(
              "ProtocoloGerador/PostProtocoloGeradorDestinosPGRCC",
              destino
            );
          } else {
            resposta = await api_PUT(
              "ProtocoloGerador/PutProtocoloGeradorDestinosPGRCC",
              destino
            );
          }

          if (resposta?.data) {
            destinosSalvos.push(resposta.data);
          }
        }

        const registroAtualizado = { ...registro };
        if (registroAtualizado.protocoloGerador?.[0]) {
          registroAtualizado.protocoloGerador[0].protocoloGeradorDestinosPGRCC =
            destinosSalvos;
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Erro",
          error?.message ?? "Erro na operação",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (item) {
      setRegistro(item);
      loadOptionsDestinos();
    }
  }, [item]);

  return (
    <Card className="card-stats">
      <CardBody>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Container style={{ maxWidth: "1000px", margin: "0 auto" }}>
            <h2 className="titulo-solicitacao">Destinos</h2>
            <Row className="align-items-end">
              <Col md="12" lg="9">
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">*</span> Selecione o Destino
                    </label>
                  </b>
                  <Select
                    options={optionsDestinos}
                    value={selectedDestino}
                    onChange={(option) => setSelectedDestino(option)}
                    placeholder="Selecione"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md="12" lg="3">
                <Button
                  color="primary"
                  type="button"
                  className="w-100"
                  onClick={handleAdicionarTransportador}
                >
                  Adicionar <i className="fas fa-plus"></i>
                </Button>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <MaterialTable
                  title=""
                  columns={[
                    { title: "Razão Social", field: "razaoSocial" },
                    {
                      title: "CPF/CNPJ",
                      field: "cpf_Cnpj",
                      render: (rowData) =>
                        mascaras.cpfcnpjMask(rowData.cpf_Cnpj),
                    },
                    {
                      title: "Celular",
                      field: "celular",
                      render: (rowData) =>
                        mascaras.celularMask(rowData.celular),
                    },
                  ]}
                  data={destinosSelecionados}
                  isLoading={false}
                  actions={[
                    {
                      icon: "delete",
                      tooltip: "Remover",
                      onClick: async (event, rowData) =>
                        handleDeleteDestino(rowData),
                    },
                  ]}
                  localization={table_translate}
                  options={{
                    ...table_style,
                    actionsColumnIndex: -1,
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="text-left">
                <Button
                  color="secondary"
                  onClick={() => handleStepAnterior(registro)}
                  className="btn-mobile"
                >
                  <i className="fas fa-chevron-left"></i> Voltar
                </Button>
              </Col>
              <Col lg="6" className="text-right">
                <Button color="success" className="btn-mobile" type="submit">
                  Próxima Etapa <i className="fas fa-chevron-right"></i>
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </CardBody>
    </Card>
  );
}
